import { Error } from "@mui/icons-material";
import {
  Autocomplete,
  FormControl,
  LinearProgress,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import useCustomSearchParam from "../../hooks/useCustomSearchParam";
import { useGetClinicUsers } from "../../hooks/useGetUsers";
import { pendingFilterValues } from "../../features/admin/pendingAppointments/components/PendingAppointmentsFilter";

export default function UserFilter({ param = "user", testId }) {
  const { t } = useTranslation();
  const { searchFn, searchParams } = useCustomSearchParam(param, [
    pendingFilterValues.pet,
  ]);
  const { data: users, error, isLoading } = useGetClinicUsers();

  const selectedUserId = searchParams.get(param) || "";

  function handleFilterChange(_, value) {
    if (value?.userDetails != null) {
      searchFn(value.userDetails.id);
    } else {
      searchFn(null);
    }
  }

  if (isLoading) return <LinearProgress sx={{ width: "100%" }} />;
  if (error && !isLoading) return <Error color="error" />;

  return (
    <FormControl fullWidth size="small">
      <Autocomplete
        size="small"
        options={users || []}
        getOptionLabel={(option) =>
          option?.userDetails
            ? `${option.userDetails.lastName ? option.userDetails.lastName : ""} ${option.userDetails.firstName} ${option.userDetails.email ? option.userDetails.email : ""}`
            : ""
        }
        value={
          users?.find(
            (u) => String(u.userDetails.id) === String(selectedUserId)
          ) || null
        }
        onChange={handleFilterChange}
        isOptionEqualToValue={(option, value) =>
          option.userDetails.id === value.userDetails.id
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={t("User")}
            placeholder={t("SearchUserPlaceholder")}
            inputProps={{
              ...params.inputProps,
              ...(testId && { "data-testid": testId }),
            }}
          />
        )}
        clearOnEscape
        clearText={t("Clear")}
        closeText={t("Close")}
        openText={t("Open")}
      />
    </FormControl>
  );
}
